// Blog taxonomy helpers backed by canonical document content.
import { listDocuments } from './queries';
export const BLOG_TAGS = [
    'party-central',
    'games',
    'features',
    'news',
    'hot-takes',
];
export const isValidBlogTag = (tag) => BLOG_TAGS.includes(tag);
export const formatBlogTag = (tag) => {
    const labels = {
        'party-central': 'Party Central',
        games: 'Games',
        features: 'Features',
        news: 'News',
        'hot-takes': 'Hot Takes',
    };
    return labels[tag];
};
export const listBlogDocumentsForAudience = (audienceTag, count = 3) => {
    const audienceDocuments = listDocuments({
        kind: 'blog',
        tags: [audienceTag],
        sortBy: 'publishedAt-desc',
    });
    if (audienceDocuments.length >= count) {
        return audienceDocuments.slice(0, count);
    }
    const backfillDocuments = listDocuments({
        kind: 'blog',
        tags: ['games'],
        sortBy: 'publishedAt-desc',
    }).filter((document) => !audienceDocuments.some((audienceDocument) => audienceDocument.slug === document.slug));
    return [...audienceDocuments, ...backfillDocuments].slice(0, count);
};
//# sourceMappingURL=blogTags.js.map